/**
 * This helper contains prerequisite functions required for data table widget display
 * ie. Generate conditionStringForm the condition object of un foldable conditional template
 *
 * The helpers are not vue migration specific conversion so try to avoid adding such code related to migration compatibility here
 * Add widget render prerequisite only which needs to be sets in the widget object before the widget renders
 *
 */
import moment from 'moment-timezone';

export const generateConditionStringFromObj = (conditionalTemplates) => {
  if (!conditionalTemplates || conditionalTemplates.length === 0) {
    return [];
  }
  return conditionalTemplates.map((template) => ({
    ...template,
    id: Math.random().toString(36).slice(2, 11),
    conditionString: prepareCondition(template.conditions.group)
  }));
};
let condition = '';

const prepareCondition = (group) => {
  if (!group) {
    return '';
  }
  const operator = group.condition === 'AND' ? '&&' : '||';
  if (group?.groups?.length) {
    const ruleExists = !(group.rules.length === 0 || !group.rules[0].key);
    const groupCondition = group.groups
      .map((group) => prepareCondition(group))
      .filter((group) => group !== '')
      .join(` ${operator} `);
    /*  If the groupCondition is empty string than operator and empty string should not be added in the condition */
    const subString = groupCondition ? ` ${operator} ${groupCondition})` : `)`;
    condition = ruleExists ? `(` + prepareConditionOfFoldableContent(group) + `${subString}` : `${groupCondition}`;
    return condition;
  }
  condition = prepareConditionOfFoldableContent(group);
  return condition;
};

const getRuleValue = (rule) => (typeof rule?.value === 'object' ? rule?.value?.value : rule?.value);

const prepareConditionOfFoldableContent = (group) => {
  // There are some cases when the conditions are mis configured
  if (!group || group.rules.length === 0 || !group.rules[0].key) {
    return '';
  }
  let operation = group.condition === 'AND' ? '&&' : '||';

  let condition = group.rules.reduce((acc, rule, index) => {
    let data = getRuleValue(rule);
    if (index > 0) {
      acc += ` ${operation} `;
    }
    return acc + generateClause(`${data}`, rule);
  }, '(');
  return `${condition} )`;
};

const generateClause = (data, rule) => {
  let operators = {
    '=': ' == ',
    '<>': ' != ',
    '<': ' < ',
    '<=': ' <= ',
    '>': ' > ',
    '>=': ' >= '
  };
  if (rule.operator === 'IN') {
    return `"${data}".split(',').indexOf('[[${rule.key}]]') > -1 || "${data}".split(',').map(Number).indexOf('[[${rule.key}]]') > -1`;
  }
  if (rule.operator === 'IS NULL') {
    return `'[[${rule.key}]]' === 'null'`;
  }
  if (rule.operator === 'IS NOT NULL') {
    return `'[[${rule.key}]]' !== 'null'`;
  }
  if (['BETWEEN', 'NOT BETWEEN'].includes(rule.operator)) {
    const timeMapping = {
      'Current Year': 'year',
      'Current Month': 'month',
      'Current Week': 'isoweek',
      'Current Day': 'day'
    };
    const startDate = moment().startOf(timeMapping[getRuleValue(rule)]).valueOf();

    const endDate = moment().endOf(timeMapping[getRuleValue(rule)]).valueOf();

    if (rule.operator === 'BETWEEN') {
      return `(new Date('[[${rule.key}]]').getTime() >= ${startDate} && new Date('[[${rule.key}]]').getTime() <= ${endDate})`;
    }
    return `(new Date('[[${rule.key}]]').getTime() < ${startDate} || new Date('[[${rule.key}]]').getTime() > ${endDate})`;
  }

  /**
   * Below condition is for > , < , =, <> , >= ,<= for any type (string , number)
   * For number values in condition value (RHS of operator) will not be wrapped in `'` to get correct comparison for <,>
   *
   */
  let rhsOperand = data;
  if (!rhsOperand.trim() || isNaN(rhsOperand)) {
    if (rhsOperand.match(/\[\[.*?\]\]/)) {
      rhsOperand = `'{{${data}}}'`;
    } else {
      rhsOperand = `'${data}'`;
    }
  }
  return `'[[${rule.key}]]' ${operators[rule.operator]} ${rhsOperand}`;
};
